(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Parlx", [], factory);
	else if(typeof exports === 'object')
		exports["Parlx"] = factory();
	else
		root["Parlx"] = factory();
})(typeof window !== "object" ? global.window = global : window, function() {
return 